import Vue from 'vue';
import axios from 'axios';

import param from 'jquery-param';
window.eventHub = new Vue();
export default {
  post(request) {
    return axios
      .post(`${window.serverURL}ajax.php`, param(request), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        withCredentials: true
      })
      .then(response => {
        let data = response.data;
        if (
          data & data.generalCheckV3 &&
          data.generalCheckV3['V3UpdateAvailable']
        ) {
          eventHub.$emit('updateAvailable', {
            update: data.generalCheckV3['V3UpdateAvailable']
          });
        }
        if (data && data.notifications) {
          console.log('got a new notification');
          eventHub.$emit('sendNotification', {
            notifications: data.notifications
          });
        }
        if (data && data.data && data.data.getWaitData) {
          eventHub.$emit('refreshHistoryImmediately', {
            forcedAjaxInterval: 1
          });
        } else if (
          data &&
          typeof data.sendNextAjaxCallAfter != 'undefined' &&
          data.sendNextAjaxCallAfter != null
        ) {
          eventHub.$emit('refreshHistory', {
            sendNextAjaxCallAfter: data.sendNextAjaxCallAfter,
            forcedAjaxInterval: 5
          });
        } else {
          eventHub.$emit('clearRefreshHistory');
        }
        return Promise.resolve(response.data);
      })
      .catch(error => Promise.reject(error));
  }
};



// WEBPACK FOOTER //
// ./src/store/utils/api.js